export default __webpack_public_path__ + "static/media/terms-of-use.1e54be84.svg";